import { EventEmitter, } from '@angular/core';
var PatientSectionsListComponent = /** @class */ (function () {
    function PatientSectionsListComponent() {
        this.changeSection = new EventEmitter();
    }
    return PatientSectionsListComponent;
}());
export { PatientSectionsListComponent };
